import clientAxios from "../client";

import type { BuyPlanType } from "@/common/types/plan/plan";

export async function planList(account_id: string) {
  return await clientAxios.get(`account/${account_id}/plan/list`);
}

export async function planGet(account_id: string, plan_id: string) {
  return await clientAxios.get(`account/${account_id}/plan/${plan_id}/show`);
}
